var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurexbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 107 60",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.58 27.33 218.24.62h11l13.62 19.19L256.46.62h10.8l-19.34 26.63 21.54 30.07h-10.81l-15.89-22.48-15.9 22.48h-10.81Z",
    transform: "translate(-165,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.06.63H13.72v31.63h-8L0 40.56h13.72v16.76h9.08V40.56h6.34c18.48 0 26.55-5.09 26.55-20S47.62.63 29.06.63Zm1.33 31.63h-7.6V8.69h7.6c10.73 0 16 2.51 16 11.75s-5.27 11.82-16 11.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurexbox);
export default __webpack_public_path__ + "static/media/purexbox.cf607b0dc0e03c6996989288fb13f48b.svg";
export { ForwardRef as ReactComponent };